import Label from "./lable";
import "./style.css";

const toLocalDatetimeString = (date) =>
	`${date.toLocaleDateString().split(".").reverse().join("-")}T${date.toLocaleTimeString()}`;

const InputDT = ({ s, v, setValue }) => {
	const {
		_id,
		name,
		title = "",
		width = "160px",
		style = {},
		off,
		disabled,
	} = s;

	// Убираем ошибку "Invalid DateTInvalid Date" когда нет v. Kaor00
	// const value = v? toLocalDatetimeString(new Date(v)) : "";
const formatDateForInput = (dateStr) => {
  if (!dateStr || dateStr.startsWith("0001-01-01")) return "";
  const d = new Date(dateStr);
  return toLocalISOString(d);
};
function toLocalISOString(date) {
  const tzOffset = date.getTimezoneOffset() * 60000; // смещение в миллисекундах
  const localISO = new Date(date.getTime() - tzOffset).toISOString();
  return localISO.slice(0, 19); // "2025-10-30T14:30:00"
}
	const handleOnChange = (e) => {
		const tv =  e.target.value
		if (!tv) return
		setValue(name, new Date(tv).toISOString());
	}

	let cls = ["skin-input-dt", "input-base"];
	cls = cls.join(" ");
	if (off) style.display = "none";

	return (
		<div className={cls} style={style}>
			<Label label={s?.label} />
			<div className="input">
				<input
					id={_id}
					type="datetime-local"
					name={name}
					value={formatDateForInput(v)}
					disabled={disabled}
					style={{ width: width }}
					title={title}
					onChange={handleOnChange}
				/>
			</div>
		</div>
	);
};

export default InputDT;
